import OktaSignIn from "@okta/okta-signin-widget";
import { OktaAuth } from "@okta/okta-auth-js";
import { user, contract } from "../stores/index";
import { navigate } from "svelte-routing";
import { UsersRepository } from "../repositories";
import getFile from "./xml";
const config = getFile("/config.json");

let oktaSignIn;
if (config.OKTA_ISSUER) {
  const authClient = new OktaAuth({
    issuer: config.OKTA_ISSUER,
    clientId: config.OKTA_CLIENT_ID,
    redirectUri: config.REDIRECT_URI
  });
  authClient.start();

  oktaSignIn = new OktaSignIn({
    issuer: config.OKTA_ISSUER,
    clientId: config.OKTA_CLIENT_ID,
    redirectUri: config.REDIRECT_URI,
    features: {
      rememberMe: false,
      // https://github.com/okta/okta-signin-widget/issues/1380
      webauthn: true
    },
    authClient
  });
}

function setUserToken(token) {
  const expirationDate = new Date(token.expiresAt * 1000);

  let userStore;
  user.subscribe((data) => {
    userStore = data;
  });

  user.set({
    ...userStore,
    token: {
      token: token.accessToken,
      type: token.tokenType,
      exp: expirationDate
    }
  });
}

async function getToken() {
  try {
    let token = await oktaSignIn.authClient.tokenManager.get("accessToken");

    if (!token) {
      return await logout();
    } else {
      if (oktaSignIn.authClient.isAuthenticated()) {
        token = await oktaSignIn.authClient.tokenManager.renew("accessToken");
        setUserToken(token);
        console.debug(
          "token manually renewed till: ",
          new Date(token.expiresAt * 1000).toLocaleString()
        );
      } else {
        return await logout();
      }
    }
  } catch (e) {
    const token = await oktaSignIn.authClient.tokenManager.get("refreshToken");
    if (!token || oktaSignIn.authClient.tokenManager.hasExpired(token))
      return await logout();
    throw e;
  }
}

async function login() {
  try {
    // set token for first time
    const token = await oktaSignIn.authClient.tokenManager.get("accessToken");
    setUserToken(token);

    const meResult = await UsersRepository.me();

    let userStore;
    user.subscribe((data) => {
      userStore = data;
    });

    if (meResult.contracts.length === 0 && !meResult.data.isMaster) {
      throw new Error({
        message: "This user is not assigned to any application"
      });
    } else {
      contract.set(meResult.contracts[0]);

      const contractApps = await UsersRepository.getUserApps(
        meResult.data.id,
        meResult.contracts[0]
      );
      const policies = await UsersRepository.getUserPolicies(meResult.data.id);

      user.set({
        data: meResult.data,
        contracts: meResult.contracts,
        apps: contractApps.list,
        policies: policies.list,
        ...userStore
      });
    }
  } catch (error) {
    user.set(null);
    logout();
  }
}

async function logout() {
  oktaSignIn.authClient.signOut({
    postLogoutRedirectUri: config.REDIRECT_URI
  });
  oktaSignIn.remove();
  user.set(null);
  contract.set(null);
  navigate("/");
}

const okta = {
  login,
  oktaSignIn,
  logout,
  getToken
};

export default okta;
